// Datei: init_tomSelect.js
import TomSelect from 'tom-select/popular';
import * as utils from "../components/utils";

export function initTomSelect(selector) {
    const SCRIPT_NAME = 'initTomSelect.js';
    const ELEMENTS = document.querySelectorAll(selector);

    if (ELEMENTS.length === 0) {
        utils.consoleLog(SCRIPT_NAME, `initTomSelect: Keine Elemente für Selektor "${selector}" gefunden. Abbruch.`);
        return;
    }

    ELEMENTS.forEach((el) => {
        const TYPE = el.getAttribute('data-tomSelect');

        // Überschreibt die default Placeholders unten definiert in der Config.
        const PLACEHOLDER = el.getAttribute('data-tomSelect-Placeholder');

        let config = {};
        switch (TYPE) {
            case 'multiple':
                config = {
                    plugins: {
                        dropdown_input: {},
                        remove_button: {
                            title: utils.getLanguageText("general.tomSelect.remove")
                        }
                    },
                    maxOptions: null,
                    create: false,
                    maxItems: null,
                    hideSelected: true,
                    placeholder: PLACEHOLDER ? PLACEHOLDER : utils.getLanguageText("general.tomSelect.multipleOptionsPlaceholder")
                };
                break;

            case 'single-comboBox':
                config = {
                    plugins: {
                        dropdown_input: {},
                        remove_button: {
                            title: utils.getLanguageText("general.tomSelect.remove")
                        }
                    },
                    maxOptions: null,
                    maxItems: 1,
                    create: true,
                    sortField: {
                        field: "text",
                        direction: "asc"
                    },
                    placeholder: PLACEHOLDER ? PLACEHOLDER : utils.getLanguageText("general.tomSelect.searchOrAddPlaceholder")
                };
                break;

            case 'single':
            default:
                config = {
                    plugins: {
                        dropdown_input: {}
                    },
                    maxOptions: null,
                    create: false,
                    maxItems: 1,
                    hideSelected: false,
                    placeholder: PLACEHOLDER ? PLACEHOLDER : utils.getLanguageText("general.tomSelect.singleOptionsPlaceholder")
                };
                if (TYPE !== 'single') {
                    utils.consoleLog(SCRIPT_NAME, `Unbekannter Typ "${TYPE}" auf Element`, el);
                    return;
                }
                break;
        }


        new TomSelect(el, {
            ...config,
            render: {
                option: function (data, escape) {
                    return data.content
                        ? `<div class="option">${data.content}</div>`
                        : `<div class="option">${escape(data.text)}</div>`;
                },
                item: function (data, escape) {
                    return data.content
                        ? `<div class="item">${data.content}</div>`
                        : `<div class="item">${escape(data.text)}</div>`;
                },
                option_create: function (data, escape) {
                    return `<div class="create">${utils.getLanguageText("general.tomSelect.addText")}&nbsp;${escape(data.input)}</div>`;
                },
                no_results: function () {
                    return `<div class="no-results">${utils.getLanguageText("general.tomSelect.noResults")}</div>`;
                }
            },
            onInitialize: function () {
                this.dropdownResizeHandler = null;

                const adjustDropdownHeight = () => {
                    if (this.isOpen) {
                        const CONTROL_RECT = this.control.getBoundingClientRect();
                        const VIEWPORT_HEIGHT = window.innerHeight;
                        const SPACE_BELOW = VIEWPORT_HEIGHT - CONTROL_RECT.bottom;
                        const MAX_SPACE_BELOW = SPACE_BELOW - 24;
                        const DROPDOWN_HEIGHT = this.dropdown.scrollHeight;
                        const UPDATED_MAX_HEIGHT = Math.min(DROPDOWN_HEIGHT, Math.max(0, MAX_SPACE_BELOW));
                        this.dropdown.style.maxHeight = `${UPDATED_MAX_HEIGHT}px`;
                        this.dropdown.style.marginBottom = '';
                        this.dropdown.style.marginTop = '';
                    }
                };

                this.dropdownResizeHandler = () => {
                    adjustDropdownHeight();

                    if (!this.isOpen) return;

                    const CONTROL_RECT = this.control.getBoundingClientRect();
                    const VIEWPORT_WIDTH = window.innerWidth;
                    const MIN_MARGIN = 24;
                    const MAX_WIDTH = VIEWPORT_WIDTH - MIN_MARGIN * 2;

                    let widestOptionWidth = this.control.offsetWidth;
                    const OPTIONS = this.dropdown.querySelectorAll(".option");

                    OPTIONS.forEach(opt => {
                        const CLONE = opt.cloneNode(true);
                        CLONE.style.display = 'inline-block';
                        CLONE.style.position = 'absolute';
                        CLONE.style.visibility = 'hidden';
                        CLONE.style.height = 'auto';
                        CLONE.style.width = 'auto';
                        document.body.appendChild(CLONE);
                        const WIDTH = CLONE.offsetWidth;
                        widestOptionWidth = Math.max(widestOptionWidth, WIDTH);
                        document.body.removeChild(CLONE);
                    });

                    const FINAL_WIDTH = Math.min(widestOptionWidth + 32, MAX_WIDTH);

                    const LEFT_SPACE = CONTROL_RECT.left;
                    const RIGHT_SPACE = VIEWPORT_WIDTH - CONTROL_RECT.right;

                    this.dropdown.style.width = `${FINAL_WIDTH}px`;
                    this.dropdown.style.position = 'absolute';
                    this.dropdown.style.zIndex = 9999;
                    this.dropdown.style.top = `${this.control.offsetHeight}px`;

                    if (RIGHT_SPACE < FINAL_WIDTH && LEFT_SPACE > RIGHT_SPACE) {
                        this.dropdown.style.left = 'auto';
                        this.dropdown.style.right = '0';
                    } else {
                        this.dropdown.style.left = '0';
                        this.dropdown.style.right = 'auto';
                    }
                };
                window.addEventListener('resize', this.dropdownResizeHandler);
                adjustDropdownHeight();
            },
            onDropdownOpen: function () {
                this.dropdownResizeHandler();

                const CONTROL_RECT = this.control.getBoundingClientRect();
                const VIEWPORT_WIDTH = window.innerWidth;
                const MIN_MARGIN = 24;
                const MAX_WIDTH = VIEWPORT_WIDTH - MIN_MARGIN * 2;

                let widestOptionWidth = this.control.offsetWidth;
                const OPTIONS = this.dropdown.querySelectorAll(".option");

                OPTIONS.forEach(opt => {
                    const CLONE = opt.cloneNode(true);
                    CLONE.style.display = 'inline-block';
                    CLONE.style.position = 'absolute';
                    CLONE.style.visibility = 'hidden';
                    CLONE.style.height = 'auto';
                    CLONE.style.width = 'auto';
                    document.body.appendChild(CLONE);
                    const WIDTH = CLONE.offsetWidth;
                    widestOptionWidth = Math.max(widestOptionWidth, WIDTH);
                    document.body.removeChild(CLONE);
                });

                const FINAL_WIDTH = Math.min(widestOptionWidth + 32, MAX_WIDTH);

                const LEFT_SPACE = CONTROL_RECT.left;
                const RIGHT_SPACE = VIEWPORT_WIDTH - CONTROL_RECT.right;

                this.dropdown.style.width = `${FINAL_WIDTH}px`;
                this.dropdown.style.position = 'absolute';
                this.dropdown.style.zIndex = 9999;
                this.dropdown.style.top = `${this.control.offsetHeight}px`;

                if (RIGHT_SPACE < FINAL_WIDTH && LEFT_SPACE > RIGHT_SPACE) {
                    this.dropdown.style.left = 'auto';
                    this.dropdown.style.right = '0';
                } else {
                    this.dropdown.style.left = '0';
                    this.dropdown.style.right = 'auto';
                }
            },
            onDropdownClose: function () {
            },
            destroy: function () {
                if (this.dropdownResizeHandler) {
                    window.removeEventListener('resize', this.dropdownResizeHandler);
                }
            },
        });
        utils.consoleLog(SCRIPT_NAME, `Tom Select initialisiert auf Element:`, el);
    });
}

